<template>
  <div class="container mx-auto">
    <div class="vx-row">
      <div class="vx-col sm:w-full md:w-full mx-auto self-center">
        <div class="vx-row flex vs-align-center">
          <div class="vx-col lg:w-1/3 md:w-full sm:w-full w-full mb-base">
            <vx-card class="p-2 h-full" style="min-height:100%">
              <div class="vx-row mb-5">
                <div class="vx-col">
                  <vs-avatar class="mb-6 block" size="80px" :src="'https://portal.escolazion.com/imagens/get/users_'+account.user.foto" />
                  <div class="text-center">
                    <!-- <p class="text-grey">{{ card_6.profession }}</p> -->
                  </div>
                </div>
                <div class="vx-col flex-1 flex flex-col">
                  <div class="flex justify-between row">
                    <h3 class="font-bold inline-block">{{ account.user.nome }}</h3>
                    <small
                      v-if="account.user.student.class"
                      class="font-bold inline-block float-right bottom"
                    >{{ account.user.student.class.nome }}</small>
                  </div>
                  <small v-if="account.user.unit.nome">{{ account.user.unit.nome }}</small>
                  <div class="flex justify-between pl-1 pr-1 mt-5">
                    <small class="font-semibold">{{ level.progress }}%</small>
                    <p class="font-semibold">{{ level.current.name }}</p>
                    <small class="text-grey">100%</small>
                  </div>
                  <vs-progress
                    height="10"
                    :percent="level.progress"
                    class="self-end block mt-1 shadow-md"
                    color="warning"
                  ></vs-progress>
                </div>
              </div>

              <div v-if="this.showRanking" class="mt-5 flex justify-between text-center">
                <span>
                  <p class="text-xl font-bold">
                    {{ this.ranking.global.rank }}º
                    <span class="block text-xs font-light">colocado</span>
                  </p>
                  <small class="text-grey">Global</small>
                </span>
                <span>
                  <p class="text-xl font-bold">
                    {{ this.ranking.unit.rank }}º
                    <span class="block text-xs font-light">colocado</span>
                  </p>
                  <small class="text-grey">Unidade</small>
                </span>
                <span>
                  <p class="text-xl font-bold">
                    {{ this.ranking.class.rank }}º
                    <span class="block text-xs font-light">colocado</span>
                  </p>
                  <small class="text-grey">Turma</small>
                </span>
              </div>
              <div
                class="border border-solid border-grey-light border-r-0 border-b-0 border-l-0 mt-base"
              >
                <div class="flex justify-between pl-1 pr-1 mt-5">
                  <small class="font-semibold">{{ this.frequency }}%</small>
                  <p class="font-semibold">Frequência</p>
                  <small class="text-grey">100%</small>
                </div>
                <vs-progress height="17" :percent="this.frequency" class="block mt-1 shadow-md"></vs-progress>
              </div>
            </vx-card>
          </div>
          <div class="vx-col lg:w-1/3 md:w-full sm:w-full w-full mb-base pb-0">
            <vx-card v-if="gameProfile" :title="'Seu herói é '+ gameProfile.character" subtitle="Seja representado pelo melhor!"  style="min-height:100%">
              <div class="vx-row flex">
                <div class="vx-col lg:w-1/2">
                  <img class="block mx-auto" style="height: 250px;" :src="require('../assets/images/zion/esquadraoz/'+gameProfile.character.toLowerCase()+'500.png')" />
                </div>
              </div>
            </vx-card>
          </div>
          <div class="vx-col lg:w-1/3 md:w-full sm:w-full w-full mb-base">
            <vx-card title="Conquistas" subtitle="Já desbloqueadas por você!" style="min-height:100%">
              <!-- <img
                class="block mx-auto"
                style="height: 350px;"
                src="https://i.imgur.com/tv7Nxro.png"
              />-->
              <div
                class="vx-row flex"
                v-if="achievements.unlocked && achievements.unlocked.length > 0"
              >
                <div
                  v-for="(achievement, index) in achievements.unlocked.slice(0, 15)"
                  v-bind:key="index"
                  class="vx-col lg:w-1/5 md:w-1/4 mb-4"
                >
                  <img class="insta-img" :src="achievement.icon_url" />
                </div>
              </div>
              <vs-button color="primary" type="filled" to="/conquistas">Ver todas as conquistas</vs-button>
            </vx-card>
          </div>
        </div>
        <div class="vx-row flex vs-align-center">
          <div class="vx-col lg:w-3/5 md:w-full sm:w-full w-full mb-base">
            <vx-card title="Destaque na ZION!" subtitle="O que está em alta agora" class>
              <youtube player-width="100%" video-id="aPHX5LoSEAQ"></youtube>
            </vx-card>
          </div>
          <div class="vx-col lg:w-2/5 md:w-full sm:w-full w-full mb-base">
            <vx-card title="Instagram" subtitle="@escolazion" class="overlay-card overflow-hidden">
              <div class="vx-row flex" v-if="instagram.grams && instagram.grams.length > 0">
                <div
                  v-for="(gram, index) in instagram.grams"
                  v-bind:key="index"
                  class="vx-col lg:w-1/2"
                >
                  <a :href="gram.link" target="_blank">
                    <img
                      class="insta-img"
                      :src="gram.images.standard_resolution.url"
                      :alt="gram.text"
                    />
                    <p class="insta-caption">{{gram.caption.text.substring(0, 100)}}...</p>
                  </a>
                </div>
              </div>
            </vx-card>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import {
  getRankingGlobal,
  getRankingByUnit,
  getRankingByClass,
  getLevel
} from "../_services/point.service.js";
import { getFrequency } from "../_services/frequency.service.js";
import { getGrams } from "../_services/instagram.service.js";

import VueApexCharts from "vue-apexcharts";
import ZDataCard from "@/components/zion/ZDataCard.vue";
import VuePerfectScrollbar from "vue-perfect-scrollbar";

import fullCalendar from "vue-fullcalendar";

import { videoPlayer } from "vue-video-player";
import "video.js/dist/video-js.css";

import achievementService from "../_services/achievement.service.js";

export default {
  data: function() {
    return {
      instagram: {
        grams: [],
      },
      frequency: 0,
      ranking: { global: { rank: 0 }, unit: { rank: 0 }, class: { rank: 0 } },
      achievements: [],
      points: 0,
      level: 0,
      showRanking: false
    };
  },
  mounted() {
    this.setRankingVisibility();
    this.fetchFrequency();
    this.fetchLevel();
    this.fetchAchievements();
    this.fetchGrams();
  },
  methods: {
    async setRankingVisibility() {
      const geekDomains = ['pzgeek.localhost', 'portalgame.ziongeek.com']
      const domain = window.location.host.split(':')[0]
      if (!geekDomains.includes(domain)) {
        this.showRanking = true
        this.fetchRanking()
      }
    },
    async fetchGrams() {
      getGrams({
        url: this.instagram.url,
        access_token: this.instagram.access_token
      }).then(grams => {
        this.instagram.grams = grams;
      });
    },
    async fetchLevel() {
      getLevel({
        studentId: this.account.user.student.id
      }).then(result => {
        this.level = result
      })
    },
    async fetchRanking() {
      getRankingGlobal({
        studentId: this.account.user.student.id
      }).then(result => {
          this.ranking.global = result
      })
      getRankingByUnit({
        studentId: this.account.user.student.id
      }).then(result => {
          this.ranking.unit = result
      })
      getRankingByClass({
        studentId: this.account.user.student.id
      }).then(result => {
          this.ranking.class = result
      })
    },
    async fetchFrequency() {
      getFrequency({
        studentId: this.account.user.student.id
      }).then(result => {
        this.frequency = result
      })
    },
    async fetchAchievements() {
      achievementService.getAll(
        this.account.user.student.id
      ).then(result => {
          this.achievements = result
      })
    }
  },
  computed: {
    ...mapState({
      account: state => state.account,
      gameProfile: state => state.gameProfile
    }),
    instapage() {
      return "https://www.instagram.com/" + this.username;
    }
  },
  components: {
    fullCalendar,
    VueApexCharts,
    ZDataCard,
    VuePerfectScrollbar,
    videoPlayer,
  }
};
</script>
<style lang="scss">
.insta-img {
  width: 100%;
  border-radius: 10px;
}
.hero-img {
  height: 50px;
  width: auto;
  margin: 2px;
}
.insta-caption {
  width: 100%;
}
.greet-user {
  position: relative;
  .decore-left {
    position: absolute;
    left: 0;
    top: 0;
  }
  .decore-right {
    position: absolute;
    right: 0;
    top: 0;
  }
}

@media (max-width: 576px) {
  .decore-left,
  .decore-right {
    width: 140px;
  }
}

.card-video {
  .video-js {
    height: 370px;
  }
}
</style>
